import { Component, TemplateRef, ViewEncapsulation } from "@angular/core";

import { Location } from "@angular/common";
import { StoreService } from "@app/shared/services/store.service";
import { UserService } from "@app/shared/services/user.service";
import { Store } from "@models/store";
import { User } from "@models/user";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { AuthService } from "@app/auth/services/auth.service";

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: "footer-only-layout",
  styleUrls: ["./footer_only.component.scss"],
  templateUrl: "./footer_only.component.html",
})
export class FooterOnlyLayoutComponent {
  menuButtons: TemplateRef<any>;

  user: User;
  store: Store;

  hover: string;
  links: any;
  showNavbar: boolean;
  showMobileNav = false;

  linkPath = [];

  constructor(
    private userService: UserService,
    protected modalService: NgbModal,
    protected location: Location,
    private storeService: StoreService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.user = this.userService.getSource().getValue();
    this.store = this.storeService.getSource().getValue();
  }

  navigate(link): void {
    this.router.navigateByUrl(link);
  }

  logout(): void {
    this.authService.logout().subscribe((response) => {
      this.router.navigateByUrl('/login');
    });
  }

  onChangeStore(storeId: number) {
    this.user.currentStoreId = storeId;
    this.userService.update(this.user).subscribe(() => {
      this.router.navigateByUrl('/dashboard');
    });
  }

  openChangeStore(content: TemplateRef<any>): void {
    this.user = this.userService.getSource().getValue();
    this.modalService.open(content);
  }
}
